module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list@3x.928c318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list@3x.png
// module id = S55g
// module chunks = 18